import React from "react"
import { Chart, ChartOptions } from "chart.js"
import { IWorkforceAssessmentDashboardPositionSummary } from "../../../../models/data/dashboard/WorkforceAssessment/WorkforceAssessmentDashboard"
import * as positionHelper from "../../../../helpers/positionHelper"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import moment from "moment"

const colors = [[78, 175, 80], [5, 188, 212], [114, 114, 114]]
const monthNames = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]

export interface IProps {
    data1
    data2?
    label1
    label2?
    positionSummaries: IWorkforceAssessmentDashboardPositionSummary[]
}
export default class WorkforceAssessmentPositionComparisonGraph extends React.Component<IProps, any> {
    download_chart
    componentDidMount() {
        this.loadChart()
    }

    componentDidUpdate() {
        this.loadChart()
    }

    groupDates(downloads) {
        const groupedDates = []
        for (let i = 11; i >= 0; i--) {
            const currentDate = new Date()
            currentDate.setMonth(currentDate.getMonth() - i)
            groupedDates.push({
                period: monthNames[currentDate.getMonth()],
                downloads: downloads[11 - i]
            })
        }

        return groupedDates
    }

    loadChart() {
        if (typeof this.download_chart !== "undefined") {
            this.download_chart.destroy()
        }

        let i = 0
        const chart_data = { labels: [], datasets: [] }
        let axisList = []

        this.props.positionSummaries.forEach(ps => {
            let color = positionHelper.getPositionColorFromBasePositionId(ps.BasePositionId)
            i++
            //const groupedData = this.groupDates(ps.PositionTimeSeries)
            chart_data.labels = ps.PositionTimeSeries.TimeSeriesData.map((item) => moment(item.Date).format("M/D/YY"))
            
            const data = ps.PositionTimeSeries.TimeSeriesData.map((item) => Math.round(item.FillRateInfo.FillRate*100))

            const dataset = {
                label: ps.PositionName,
                backgroundColor: scheduleHelper.getTransparentBackgroundColor(color), //"rgba(" + dataColor + ",0.2)",
                borderColor: color,
                pointBackgroundColor: color,
                pointBorderColor: "#64B5F6",
                pointBorderWidth: 0,
                data,
                yAxisID: "fill_rate",
            }
            chart_data.datasets.push(dataset)       
        })

        axisList.push({
            id: "fill_rate",
            position: "left",
            ticks: {
                min: 0,
                maxTicksLimit: 7,
                fontColor: "#000000"
            },
            gridLines: {
                display: true
            }
        })        
   
        if ((this.props.data1 && this.props.data1.length > 0) || (this.props.data2 && this.props.data2.length > 0)) {
            const chart_options: ChartOptions = {
                responsive: true,
                scales: {
                    scaleLabel: {
                        fontColor: "#000000",
                        labelString: "<%= ' ' + value%>"
                    },
                    yAxes: axisList,
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            }
                        }
                    ]
                },
                legend: {
                    display: !!this.props.label2
                }
            }
            const ctx: HTMLCanvasElement = document.getElementById("download_chart") as HTMLCanvasElement
            ctx.getContext("2d")
            this.download_chart = new Chart(ctx, {
                data: chart_data,
                options: chart_options,
                type: "line"
            })
        }
    }

    render() {
        return (
            <div className="WorkforceAssessmentPositionComparisonGraph">
                {((this.props.data1 && this.props.data1.length > 0) || (this.props.data2 && this.props.data2.length > 0)) &&
                    <canvas id="download_chart" />
                }
            </div>
        )
    }
}
